// extracted by mini-css-extract-plugin
export default {"embedRoot":"src-modules-embed-EmbedLayout__embedRoot_F5Qh0"};